module.exports = __webpack_public_path__ + "static/img/net-error.d339a340.png";